"use strict";

angular.module("core")
.component("btnSave", {
    templateUrl: require("./btn-save.component.html"),
    bindings: {
        onSave: "&",
        updatedMessage: "<",
        addedMessage: "<",
        workflows: "<?",
        canCreateMultiple: "<",
        submitButtonDisabled: "<?",
        fallBackState: "@?",
        btnClass: "@?",
        dropUpVariation: "@?"
    },
    controller: BtnSaveController,
    controllerAs: "btnSaveCtrl"
});

function BtnSaveController(
    $rootScope, $scope, $state, $stateParams, $timeout, gettextCatalog, FlashBag, Workflow, common
) {
    var _this = this;
    this.isEditing = $stateParams.id != "";
    this.btnClass = (typeof this.btnClass !== "undefined") ? this.btnClass : "btn btn-primary";

    _this.$onInit = function() {
        if (_this.canCreateMultiple === undefined) {
            _this.canCreateMultiple = true;
        }
        $scope.dropUpVariation = "";
        if (_this.dropUpVariation !== undefined) {
            $scope.dropUpVariation = _this.dropUpVariation;
        }

        if (_this.canCreateMultiple) {
            _this.canCreateMultiple = !hasExistingWorkflow();
        }
    }

    this.save = function(event) {
        save(event).then(function onSuccess() {
            common.scrollToTop();
            FlashBag.success(_this.updatedMessage, true);
            $timeout(function() {
                goBack();
            });
        });
    };

    this.saveAndContinue = function(event) {
        save(event).then(function onSuccess() {
            common.scrollToTop();
            FlashBag.success(_this.updatedMessage, true);
            $timeout(function() {
                $state.reload();
            });
        });
    };

    this.create = function(event) {
        save(event).then(function onSuccess(data) {
            common.scrollToTop();
            FlashBag.success(_this.addedMessage, true);
            $timeout(function() {
                if (hasExistingWorkflow()) {
                    angular.forEach(_this.workflows, function(value) {
                        var section = value.section;
                        var workflow = Workflow.getFormData(section);
                        if (workflow) {
                            Workflow.addToFormData(section, value.object, data);
                            $state.go(section, {id: workflow.id});
                        }
                    });
                }
                else {
                    goBack();
                }
            });
        });
    };

    this.createAndAddAnother = function(event) {
        save(event).then(function onSuccess() {
            common.scrollToTop();
            FlashBag.success(_this.addedMessage, true);
            $timeout(function() {
                $state.reload();
            });
        });
    };

    function goBack() {
        if (_this.fallBackState && (!$rootScope.previousLocation || $rootScope.previousLocation === $rootScope.actualLocation)) {
            $state.go(_this.fallBackState);
        }
        else {
            window.history.back();
        }
    }

    function save(event) {
        if (_this.submitButtonDisabled) {
            return;
        }

        event.currentTarget.disabled = true;
        return _this.onSave().finally(function() {
            event.currentTarget.disabled = false;
        });
    }

    function hasExistingWorkflow() {
        var hasExistingWorkflow = false;
        if (_this.workflows) {
            angular.forEach(_this.workflows, function(value) {
                var worflow = Workflow.getFormData(value.section);
                if (worflow) {
                    hasExistingWorkflow = true;
                }
            });
        }
        return hasExistingWorkflow;
    }
}



//////////////////
// WEBPACK FOOTER
// ./core/btn-save/btn-save.component.js
// module id = 615
// module chunks = 0